import superagent from 'superagent'

/**
 * The signed-in user's connected apps (WEB-7107) against the API-3658 endpoints:
 *
 *   GET    ConnectedApps/List                every app the user has connected through OAuth
 *   DELETE ConnectedApps/Revoke?clientId=…   disconnect one: 204, or 404 if it isn't connected
 *
 * Both need the user's BaseMap token. Services words its failures for the user, so the body's message is
 * shown as it is.
 */

const messageFrom = (err, fallback) => {
  const body = err && err.response ? err.response.text : null

  if (!body) return fallback

  // Messages come back as a quoted JSON string; unwrap it rather than showing the quotes.
  const trimmed = body.trim()
  try {
    const parsed = JSON.parse(trimmed)
    if (typeof parsed === 'string' && parsed.length) return parsed
  } catch (e) {
    // Not JSON - fall through and use the raw body.
  }

  return trimmed.length ? trimmed : fallback
}

const failure = (err, fallback) => {
  const error = new Error(messageFrom(err, fallback))
  error.status = err && err.status
  return error
}

const withHeaders = request => request
  .set('Content-Type', 'application/json')
  .set('Platform', 'Web')
  .set('Version', `${__version__}`)

const connectedApps = {
  /** [{clientId, name, clientType, organizationId, firstParty, scopes: [{name, description}], firstConnected, lastUsed}] */
  list: ({ token }) => {
    return new Promise((resolve, reject) => {
      withHeaders(superagent.get(`${__API_URI__}/ConnectedApps/List`))
        .set('Authorization', `Bearer ${token}`)
        .end((err, res) => {
          if (err) return reject(failure(err, 'Your connected apps could not be loaded.'))
          resolve(res.body || [])
        })
    })
  },

  revoke: ({ clientId, token }) => {
    return new Promise((resolve, reject) => {
      withHeaders(superagent.delete(`${__API_URI__}/ConnectedApps/Revoke`))
        .query({ clientId })
        .set('Authorization', `Bearer ${token}`)
        .end(err => {
          if (err) return reject(failure(err, 'That app could not be disconnected.'))
          resolve()
        })
    })
  }
}

export default connectedApps
